import { createContext, useContext } from 'react';
import axios, { AxiosResponse } from 'axios';
import { NextRouter } from 'next/router';
import { message } from 'antd';

import { IContact } from '../model/mailchimp/contact.model';
import { MailchimpStatus } from '../model/mailchimp/enums/mailchimpStatus.enum';
import { ResponseType } from '../../pages/api/mailchimp/subscribe';
import { I18nContextType } from '../../libs/i18n';

interface IMailchimpService {
  subscribe(
    contact: IContact,
    router: NextRouter,
    i18n: I18nContextType
  ): Promise<void>;
}

class MailchimpService implements IMailchimpService {
  private axiosInstance = axios.create({
    baseURL: '/api/mailchimp/',
  });

  async subscribe(
    contact: IContact,
    router: NextRouter,
    i18n: I18nContextType
  ): Promise<void> {
    try {
      let res: AxiosResponse<ResponseType>;
      if (contact.formData) {
        contact.formData.set('EMAIL', contact.EMAIL);
        contact.formData.set('FNAME', contact.FNAME);
        contact.formData.set('LNAME', contact.LNAME);
        if (contact.PHONE) {
          contact.formData.set('PHONE', contact.PHONE);
        }
        if (contact.HADDRESS) {
          contact.formData.set('HADDRESS', contact.HADDRESS);
        }
        if (contact.SUBJECT) {
          contact.formData.set('SUBJECT', contact.SUBJECT);
        }
        contact.formData.set('interests', JSON.stringify(contact.interests));

        res = await this.axiosInstance.post('subscribe', contact.formData);
      } else {
        res = await this.axiosInstance.post('subscribe', {
          contact,
        });
      }

      const shouldGoToInfoReceivedPage =
        contact.HADDRESS || contact.SUBJECT || contact.DFLAT;
      const status = shouldGoToInfoReceivedPage
        ? MailchimpStatus.INFO_RECEIVED
        : res.data.status;
      router.push(`/estado-suscripcion/${status}`);
    } catch (error) {
      message.error(i18n.t('messages.mailchimpSubscription.error'));
    }
  }
}

const mailchimpService = new MailchimpService();

const MailchimpServiceContext = createContext<IMailchimpService>(
  mailchimpService
);

const useMailchimpService = (): IMailchimpService => {
  return useContext(MailchimpServiceContext);
};

export default useMailchimpService;
